import { CommonModule, JsonPipe, NgIf, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID
} from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { TooltipTpDirective } from 'src/app/directives/tooltip-tp.directive';
import { environment } from 'src/environments/environment';
import { MapPageDetailComponent } from '../map-page-detail/map-page-detail.component';

@Component({
  selector: 'app-popup-ateco',
  templateUrl: './popup-ateco.component.html',
  styleUrls: ['./popup-ateco.component.scss'],
  standalone: true,
  imports: [CommonModule, NgIf, TooltipTpDirective, MapPageDetailComponent, JsonPipe, NgOptimizedImage],
})
export class PopupAtecoComponent implements OnInit {
  @Input() atecoCompanyObj: any;
  @Input() esponente: any;
  @Input() objType = '';
  @Input() popupAtecoIsOpen = false;
  @Input() esponenteName: string;
  @Input() agentFullName;
  @Input() hideMapInPopupAteco = false;
  @Input() correctEsponente: any;
  @Output() closePopupAtecoEvt = new EventEmitter<boolean>();

  dashboardLink = environment.dashboard + 'registrazione';

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private changeDetector: ChangeDetectorRef,
    public main: AppComponent,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
  }

  handleClosePopupAtecoEvt(): void {
    this.closePopupAtecoEvt.emit();
  }

  // SE L'UTENTE CLICCA FUORI DAL POPUP VIENE CHIUSO
  @HostListener('window:click', ['$event.target']) onClick(target): void {
    if (isPlatformBrowser(this.platformId)) {
      if (target.classList.contains('bg-modal')) {
        this.handleClosePopupAtecoEvt();
      }
    }
  }

  findSlugFromFullName(agentFullName: string): void {
    let slug = '';
    if (this.esponente) {
      slug = this.esponente.slug;
    } else {
      slug = (this.atecoCompanyObj.esponenti[0] as any).slug;
      this.atecoCompanyObj.esponenti.forEach((esp: any) => {
        if (esp.name === agentFullName) {
          slug = esp.slug;
        }
      });
    }
    this.router.navigate(['/dettaglio-agente-ateco/' + slug]);
  }
}
